import { apiClient } from './client';

export interface ResourceSyncStatus {
  resource_type: string;
  status: 'never' | 'pending' | 'running' | 'completed' | 'failed';
  item_count: number;
  completed_at: string | null;
  error_message: string | null;
}

export interface SyncStatusResponse {
  resources: Record<string, ResourceSyncStatus>;
}

export const syncApi = {
  getStatus: () =>
    apiClient
      .get<{ success: boolean; data: SyncStatusResponse }>('/sync/status')
      .then((r) => r.data.data),

  trigger: (full = true) =>
    apiClient
      .post<{ success: boolean; data: { queued: boolean; sync_type: string } }>(
        '/sync/trigger',
        { full },
      )
      .then((r) => r.data.data),
};
